<div class="custom-footer">
    <div class="row d-flex align-items-center justify-content-center">
        <div class="col-4 d-flex align-items-center justify-content-center">
            <button *ngIf="!hideCancel" type="button" class="btn primary-white-button btn-cancelar" [disabled]="cancelDisabled"
                (click)="onCancelClick.emit()">
                {{ cancelLabel }}
            </button>
        </div>
        <div class="col-4 d-flex align-items-center justify-content-center">
           <button *ngIf="showCustomButton" type="button" class="btn primary-white-button w-100" [disabled]="saveDisabled"
               (click)="onCustomButtonClick.emit()">
               {{ customButtonLabel }}
               <i class="ml-2" [ngClass]="buttonImage"></i>
           </button>
       </div>
        <div class="col-4 d-flex align-items-center justify-content-center">
            <button *ngIf="!hideSave" type="submit" class="btn primary-white-button w-100" [disabled]="saveDisabled"
                (click)="onSaveClick.emit()">
                {{ saveLabel }}
                <i class="ml-2" [ngClass]="buttonImage"></i>
            </button>
        </div>
    </div>
</div>